import React, { cloneElement, useEffect, useMemo } from "react";
import { useContext, useState } from "react";
import { getTbNameByJobName, isMasterJob, JobNames } from "../../framework.core/JobNames";
import ActionButton, { ActionButtonItem } from "../../ui/ActionButton";
import { useJournal } from "../accounting/general/journal/JournalListView";
import JobListViewContext from "./JobListViewContext";
import useGlobalOkDialog from '../../hooks/useGlobalOkDialog';
import ApplicationContext from '../../ApplicationContext';
import { ApiResult } from "../../framework.core/data/ApiResult";
import AdjustBalance from './reports/AdjustBalance';
import IfmsModal from "../../ui/IfmsModal";
import { useAppSelector } from "../../app/hooks";
import constants from "../../constants";


interface IJobListSuntekCommand {
  jobName: JobNames,
  keyProp: string,
  showTransactionImpact?: boolean,
  showFixJournal?: boolean,
  showFixLockedData?: boolean,
  showAdjustBalance?: boolean,
}

function JobListSuntekCommand({ jobName, keyProp, showTransactionImpact=true, showFixJournal=true, showFixLockedData=true, showAdjustBalance=true }: IJobListSuntekCommand) {
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement;
  const {switchJournal} = useJournal();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const appContext = useContext(ApplicationContext);
  const userState = useAppSelector(state => state.user);
  const user = userState.user;

  useEffect(() => {
    if (selectedPopupMenuItem) {
      onSubMenuClick(selectedPopupMenuItem);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPopupMenuItem]);

  const adjBalancePopupLabel = useMemo(() =>{
    switch (jobName) {
      case JobNames.Invoice:
        return "Adjust Invoice";
      case JobNames.Bill:
        return "Adjust Bill";
      case JobNames.CrDb:
        return "Adjust Credit/Debit";
      case JobNames.GInvo:
        return "Adjust General Invoice";
      case JobNames.GBill:
        return "Adjust General Bill";
      default: 
        return "Adjust Balance";
    }
  }, [jobName]);

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  async function onSubMenuClick(item:ActionButtonItem) {
    if(!selectedElement) {
      return;
    }

    switch(item.label) {
      case 'Transaction Impact':
        setSelectedPopupMenuItem(null);
        
        // appContext.setJournalType(0);

        switchJournal(jobName, selectedElement[keyProp]);
        break;

      case 'Fix Journal':
        setSelectedPopupMenuItem(null);

        if(isMasterJob(jobName,true)){
          const apiResult:ApiResult<string> = await appContext.api.fixJournalByMaster(getTbNameByJobName(jobName), jobName,selectedElement.id.toString());
          if(!apiResult || !apiResult.success) {
            await showGlobalOkDialog(<p>{apiResult?.message ?? constants.LOAD_ERROR_MESSAGE}</p>); 
          } else {
            await showGlobalOkDialog(<p>{apiResult.result}</p>); 
          }
        }
        else if(jobName === JobNames.BTLoadPlan){
          const apiResult:ApiResult<string> = await appContext.api.fixJournalByMaster(getTbNameByJobName(jobName), jobName,selectedElement.id.toString());
          if(!apiResult || !apiResult.success) {
            await showGlobalOkDialog(<p>{apiResult?.message ?? constants.LOAD_ERROR_MESSAGE}</p>); 
          } else {
            await showGlobalOkDialog(<p>{apiResult.result}</p>); 
          }
        }
        else{
          const apiResult:ApiResult<string> = await appContext.api.fixJournalByTask(getTbNameByJobName(jobName), jobName,selectedElement.id.toString());
          if(!apiResult || !apiResult.success) {
            await showGlobalOkDialog(<p>{apiResult?.message ?? constants.LOAD_ERROR_MESSAGE}</p>); 
          } else {
            await showGlobalOkDialog(<p>{apiResult.result}</p>); 
          }
        }
        break;

      case 'Fix Locked Data':
        let tbName = getTbNameByJobName(jobName);
        let tbId = selectedElement.id.toString();

        switch(jobName) {
          case JobNames.Invoice:
            tbName = selectedElement.tbName;
            tbId = selectedElement.tbId.toString();
            break;
        }
        setSelectedPopupMenuItem(null);

        const apiResult:ApiResult<number> = await appContext.api.fixOpAcct(tbName, tbId);
        if(!apiResult || !apiResult.success) {
          await showGlobalOkDialog(<p>{apiResult?.message ?? constants.LOAD_ERROR_MESSAGE}</p>); 
        } else {
          await showGlobalOkDialog(<p>{apiResult.result === 1 ? "Fixed !!" : "No change !!"}</p>); 
        }
        break; 
      
      case 'Adjust Balance':
        break;
    }
  }

  return (
    <div>
      &nbsp; &nbsp;
      {user?.isSuntekAdmin && <ActionButton
        name="list-suntek-button"
        type="primary"
        onItemSelected={(event) => setSelectedPopupMenuItem(event)}
        items={[
          // {label: 'Transaction Impact', separator: false, hidden: !showTransactionImpact, name:'sunket-transaction-impact'},
          {label: 'Fix Journal', separator: false, hidden: !showFixJournal, name:'sunket-fix-journal'},
          {label: 'Fix Locked Data', separator: false, hidden: !showFixLockedData, name:'sunket-fix-locked-data'},
          {label: 'Adjust Balance', separator: false, hidden: !showAdjustBalance, name:'sunket-adjust-balance', popupComponent: <AdjustBalance jobName = {jobName} onPopupClose={onPopupClose} />, popupLabel: adjBalancePopupLabel, popupWidth: 980 },
        ]}
      >
        Suntek
      </ActionButton>
      }
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, {onPopupClose})}
        </IfmsModal>
      ) : null}
    </div>
  )
}

export default JobListSuntekCommand;